import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "login-auth" }
const _hoisted_2 = {
  class: "login-component",
  "data-v-app": "",
  style: {}
}
const _hoisted_3 = { class: "xluweb-login-panel login-panel--login" }
const _hoisted_4 = { class: "xluweb-login-wrapper" }
const _hoisted_5 = { class: "xluweb-login-panel__header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-change__code" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xlucommon-login-icon-code" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-change__title" }, " 扫码登录 ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "xluweb-login-qr-code"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", null, "扫码登录", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "xluweb-login-qr-code__text" }, [
  /*#__PURE__*/_createTextVNode(" 打开"),
  /*#__PURE__*/_createElementVNode("span", null, "迅雷盒子App"),
  /*#__PURE__*/_createTextVNode(" ，扫码登录 ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-qr-code__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "data:image/png;base64,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",
    alt: "二维码"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "xluweb-login-qr-code__note" }, null, -1)
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "xluweb-login-tabs" }
const _hoisted_16 = { class: "xluweb-login-tabs__title" }
const _hoisted_17 = { class: "xluweb-login-tabs__content" }
const _hoisted_18 = {
  key: 0,
  class: "xluweb-login-form"
}
const _hoisted_19 = { class: "xluweb-login-form__item" }
const _hoisted_20 = { class: "xlubase-login-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-select" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "xluweb-login-select__label" }, [
    /*#__PURE__*/_createTextVNode(" +86 "),
    /*#__PURE__*/_createElementVNode("i", { class: "xlucommon-login-icon-arrow-down" })
  ])
], -1)
const _hoisted_22 = { class: "xluweb-login-form__item" }
const _hoisted_23 = { class: "xlubase-login-content" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "xlucommon-login-icon-note" }, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "xluweb-login-form"
}
const _hoisted_27 = { class: "xluweb-login-form__item" }
const _hoisted_28 = { class: "xlubase-login-content" }
const _hoisted_29 = { class: "xluweb-login-form__item" }
const _hoisted_30 = { class: "xlubase-login-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "xluweb-login-icon-eye" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "xlucommon-login-icon-note" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "xluweb-login-form__tips" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://i.xunlei.com/xluser/validate/enter/findpwd_enter.html?redirect_uri=https%3A%2F%2Fi.xunlei.com%2Fcenter%2Faccount%2Fpersonal%2Fauth%2F%3Fui_client_id%3DYvRh8xuh1qTMewHv%26ui_key%3Dc%26ui_client_key%3Dc%26redirect_uri%3Dhttps%253A%252F%252Fi.xunlei.com%252Fcenter%252Faccount%252Fpersonal%252Foauth%252F%253Fclient_id%253DYvRh8xuh1qTMewHv%2526ui_key%253Dc%2526redirect_uri%253Dhttps%25253A%25252F%25252Fpre-hezi.xunlei.com%25252Fyc%25252Flogin%25252F%25253Fplm%25253D%252526platform%25253D%252526sso_sign_in_in_iframe%25253D%2526scope%253Dprofile%252Boffline%252Bpan%252Bsso%252Buser%2526state%253Dstate-co2x3paeuor%2526response_type%253Dcode%2526code_challenge%253DSSoMLz7zZ2XjjFDeNKzonv6gQX19AZuH1TmW4onqgDs%2526code_challenge_method%253DS256%2526sign_out_uri%253D"
  }, "忘记密码？")
], -1)
const _hoisted_34 = { class: "xluweb-login-button-wrapper" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-operate" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://help.xunlei.com/"
  }, "登录遇到问题？"),
  /*#__PURE__*/_createElementVNode("p", null, " 未注册手机号登录后将自动创建帐号 ")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, "其他登录方式", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "xlucommon-login-icon-xunlei" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "xluweb-login-way__title" }, " 迅雷登录 ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "xlucommon-login-agreement" }, [
  /*#__PURE__*/_createElementVNode("span", null, "登录即表示"),
  /*#__PURE__*/_createTextVNode("同意"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://i.xunlei.com/xluser/legal/agreement.html"
  }, "《用户协议》"),
  /*#__PURE__*/_createTextVNode(" 及 "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://i.xunlei.com/xluser/privacy.html"
  }, "《隐私协议》")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { id: "shield-app" }, null, -1)

import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import sso, { auth } from '@remote/utils/sso'
import {oAuth2ClientOptions} from '@remote/api/config'
import { IErrorRes } from '@remote/type'

type TLoginType = 'passwordAuthLogin' | 'mobileAuthLogin' | 'scanCodeLogin'
type TLoginParams = {
  loginType: TLoginType
  username: string
  password: string
  phoneNumber: string
  verificationCode: string
  isGettingVerificationCode: boolean
  theGetVerificationCodeCountdown: number
  isLoggingIn: boolean
  errorMessage: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const loginParams = reactive<TLoginParams>({
  loginType: 'passwordAuthLogin',
  username: '',
  password: '',
  phoneNumber: '',
  verificationCode: '',
  errorMessage: '',
  isGettingVerificationCode: false,
  theGetVerificationCodeCountdown: 60,
  isLoggingIn: false,
})

let verification

const handleOnChangeLoginType = (type: TLoginType) => {
  loginParams.loginType = type
}

const getErrorMessage = (errorInfo:IErrorRes):string => {
  if (errorInfo?.details?.length) {
    return errorInfo?.details[errorInfo?.details?.length - 1].message
  } else if (errorInfo.error_description) {
    return errorInfo.error_description
  } else if (errorInfo.error) {
    return errorInfo.error
  } else {
    return `操作失败[${errorInfo.error_code}]`
  }
}

const handleOnGetVerification = async () => {
  if (!loginParams.phoneNumber) {
    loginParams.errorMessage = '手机号不能为空'
    return
  }
  try {
    loginParams.isGettingVerificationCode = true
    verification = await auth.getVerification({
      phone_number: '+86 ' + loginParams.phoneNumber,
      target: 'ANY',
    })
    console.log('verification', verification)
    const timer = setInterval(() => {
      if (loginParams.theGetVerificationCodeCountdown > 0) {
        loginParams.theGetVerificationCodeCountdown = loginParams.theGetVerificationCodeCountdown - 1
      } else {
        loginParams.isGettingVerificationCode = false
        clearInterval(timer)
        loginParams.theGetVerificationCodeCountdown = 60
      }
    }, 1000)
  } catch(error) {
    loginParams.isGettingVerificationCode = false
    loginParams.errorMessage = getErrorMessage(error)
  }
}


const handleOnLogin = async () => {
  let result
  loginParams.isLoggingIn = true

  try {
    // 账号密码登录
    if (loginParams.loginType === 'passwordAuthLogin') {
      if (!loginParams.username || !loginParams.password) {
        loginParams.errorMessage = !loginParams.username ? '帐号不能为空' : '密码不能为空'
        loginParams.isLoggingIn = false
        return
      }

      result = await auth.signIn({
        username: '+86 ' + loginParams.username,
        password: loginParams.password,
        client_secret: oAuth2ClientOptions.clientsecret,
      })
      // 手机验证码登录
    } else if (loginParams.loginType === 'mobileAuthLogin') {
      if (!loginParams.phoneNumber || !loginParams.verificationCode) {
        loginParams.errorMessage = !loginParams.phoneNumber ? ' 手机号不能为空' : '请先获取验证码'
        loginParams.isLoggingIn = false
        return
      }

      let verifyResult = await auth.verify({
        verification_code: loginParams.verificationCode,
        verification_id: verification ? verification.verification_id : '',
      })
      let isUser = verification ? verification.is_user : false
      // 用户已存在则登录
      if (isUser) {
        // 登录
        result = await auth.signIn({
          username: '+86 ' + loginParams.phoneNumber,
          verification_code: loginParams.verificationCode,
          verification_token: verifyResult.verification_token,
        })
        // 用户不存在则注册
      } else {
        // 注册
        result = await auth.signUp({
          phone_number: '+86 ' + loginParams.phoneNumber,
          // password: '*******', // 密码
          verification_code: loginParams.verificationCode,
          verification_token: verifyResult.verification_token,
          client_secret: oAuth2ClientOptions.clientsecret,
          // local: 'zh-cn',
          // name: '100****1234',
        })
      }
    }
    console.log('login result', result)
    store.dispatch('login', {checkRunner: true})
    router.replace('/home')
  } catch (error) {
    console.log('login err', error)
    loginParams.isLoggingIn = false
    loginParams.errorMessage = getErrorMessage(error)
  }
}

const handleOnXunleiAuthLogin = async () => {
  loginParams.isLoggingIn = true
  try {
    // 跳转三方登录页面
    await sso.init()
    await  sso.signIn()
  } catch (error) {
    console.log('login err', error)
    loginParams.isLoggingIn = false
    loginParams.errorMessage = getErrorMessage(error)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "xluweb-login-change",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOnChangeLoginType(_unref(loginParams).loginType === 'scanCodeLogin' ? 'passwordAuthLogin' : 'scanCodeLogin')))
            }, _hoisted_8)
          ]),
          (_unref(loginParams).loginType === 'scanCodeLogin')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_14))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["xluweb-login-tabs__item", { 'is-active': _unref(loginParams).loginType === 'passwordAuthLogin' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOnChangeLoginType('passwordAuthLogin')))
                    }, "帐号密码登录", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["xluweb-login-tabs__item", { 'is-active': _unref(loginParams).loginType === 'mobileAuthLogin' }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOnChangeLoginType('mobileAuthLogin')))
                    }, "手机验证登录", 2)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_unref(loginParams).loginType === 'mobileAuthLogin')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "xlubase-login-input",
                                  placeholder: "请输入手机号",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(loginParams).phoneNumber) = $event))
                                }, null, 512), [
                                  [_vModelText, _unref(loginParams).phoneNumber]
                                ])
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "xlubase-login-input",
                                  placeholder: "请输入验证码",
                                  maxlength: "6",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(loginParams).verificationCode) = $event))
                                }, null, 512), [
                                  [_vModelText, _unref(loginParams).verificationCode]
                                ]),
                                _createElementVNode("span", {
                                  class: "xlubase-login-content__code",
                                  disabled: !_unref(loginParams).phoneNumber,
                                  onClick: handleOnGetVerification
                                }, _toDisplayString(_unref(loginParams).isGettingVerificationCode ? (
                          _unref(loginParams).theGetVerificationCodeCountdown + '秒后重新获取') : '获取验证码'), 9, _hoisted_24)
                              ]),
                              _createElementVNode("p", {
                                class: _normalizeClass(["xlucommon-login-note", { 'is-show': !!_unref(loginParams).errorMessage }])
                              }, [
                                _hoisted_25,
                                _createTextVNode(" " + _toDisplayString(_unref(loginParams).errorMessage), 1)
                              ], 2)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(loginParams).loginType === 'passwordAuthLogin')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "xlubase-login-input",
                                  placeholder: "请输入手机号",
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(loginParams).username) = $event))
                                }, null, 512), [
                                  [_vModelText, _unref(loginParams).username]
                                ])
                              ])
                            ]),
                            _createElementVNode("li", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "password",
                                  class: "xlubase-login-input",
                                  placeholder: "请输入密码",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(loginParams).password) = $event))
                                }, null, 512), [
                                  [_vModelText, _unref(loginParams).password]
                                ]),
                                _hoisted_31
                              ]),
                              _createElementVNode("p", {
                                class: _normalizeClass(["xlucommon-login-note", { 'is-show': !!_unref(loginParams).errorMessage }])
                              }, [
                                _hoisted_32,
                                _createTextVNode(" " + _toDisplayString(_unref(loginParams).errorMessage), 1)
                              ], 2)
                            ])
                          ]),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["xlucommon-login-button", { 'is-loading': _unref(loginParams).isLoggingIn}]),
                    onClick: handleOnLogin
                  }, " 登录 ", 2)
                ]),
                _hoisted_35,
                _createElementVNode("div", { class: "xluweb-login-way" }, [
                  _hoisted_36,
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", { class: "xluweb-login-way__item" }, [
                      _createElementVNode("div", {
                        class: "xluweb-login-way__icon",
                        onClick: handleOnXunleiAuthLogin
                      }, _hoisted_38),
                      _hoisted_39
                    ])
                  ])
                ])
              ], 64)),
          _hoisted_40
        ]),
        _hoisted_41
      ])
    ])
  ]))
}
}

})